import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { DeleteModal, Modal } from "../../Modal";
import { defineRole } from "../../../utils/handleAccessRoles";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import { ROLE_COLLECTIONS } from "../../../constants/ROLES";
import donationQuery from "../../../utils/queries/bloodDonationQuery";
import moment from "moment";
import exportPDF from "../../../utils/exportPDF";
import { CSVLink } from "react-csv";
import {
  deletePackaging,
  fetchPackagingData,
} from "../../../utils/queries/packagingQuery";
import toastMessage from "../../../utils/toastMessage";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class Packages extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    filters: {
      startDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      endDate: moment().endOf("d").format("YYYY-MM-DD"),
    },
    code: "",
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.fetchData(true, {
      ...this.state.filters,
      status: this.props.status,
    });
  };

  fetchData = async (isLoading, search = {}) => {
    console.log({
      isLoading,
      search,
    });
    const updatedFilters = {
      ...this.state.filters,
      ...search,
    };

    this.setState({ filters: updatedFilters });

    this.getData(isLoading, updatedFilters);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e && e?.target ? e?.target?.value : e,
      error,
    });
  }

  returnFilters = async (search) => {
    const { page, limit } = this.state;

    let params = {
      ...search,
      page,
      limit,
      packageStatus: this.props.status,
      coolerBox: this.props.coolerBoxId,
      sample: this.props.sample,
    };

    return params;
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const params = await this.returnFilters(search);

      const { data, count, totalRecords } = await fetchPackagingData(defaultLanguage, params);
      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true, this.state.filters);
      }
    );
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].donation_number,
        key: "donation.donationNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].cooler_box,
        key: "coolerBox.name",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].cooler_box_code,
        key: "coolerBox.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].type,
        key: "coolerBox.type",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].transportation_temperature,
        key: "transportationTemperature",
      },
      {
        title: language[this.props.defaultLanguage].sample_Type,
        key: "sampleType",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].plate_number,
        key: "plateNumber.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].sample,
        key: "sample",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "donation.center.name",

        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "donation.centerSite.name",

        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].packaging_by,
        key: "addedBy.pin",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].packaging_date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].plate_number,
        key: "plateNumber.code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].driver,
        key: "driver",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].driver_contact,
        key: "driverContact",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].transfer_date,
        key: "transferDate",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].received_by,
        key: "receivedBy.pin",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].received_date,
        key: "receivedDate",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deletePackaging(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData();
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    if (!search || search === "") return this.getData(true);

    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    const donation = await donationQuery(this.props.defaultLanguage, {
      donationNumber: search,
    });

    if (donation?.length > 0) {
      await this.fetchData(true, {
        donation: donation[0]._id,
      });
    } else {
      toastMessage("error", language[this.props.defaultLanguage].no_data_found);
    }

    this.setState({
      searching: false,
    });
  };

  downloadExcel = async (search = {}) => {
    try {
      this.setState({
        isLoading: true,
      });

      const { defaultLanguage } = this.props;

      let params = await this.returnFilters(search);

      const { data } = await fetchPackagingData(defaultLanguage, params);

      const formateData = data.map((el) => {
        return {
          code: el.code,
          name: el.coolerBox.name,
          addedBy: el?.addedBy?.pin || "-",
          receivedBy: el?.receivedBy?.pin || "-",
          center: el.center.name,
          centerSite: el.centerSite.name,
          status: el.status,
          receivedDate: el.receivedDate
            ? moment(el.receivedDate).format("lll")
            : "-",
          createdAt: moment(el.createdAt).format("lll"),
        };
      });

      this.setState({
        isLoading: false,
        csvData: formateData,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async (search = {}) => {
    this.setState({
      isLoading: true,
    });

    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    let params = await this.returnFilters(search);

    const { data } = await fetchPackagingData(defaultLanguage, params);

    this.setState({
      isLoading: false,
    });

    exportPDF("Packaging", headers, data);
  };

  render() {
    const { add_package } = language[this.props.defaultLanguage];
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={this.handleSearch.bind(this)}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          addButtonText={add_package}
          fetchData={(isLoading, search) => this.fetchData(isLoading, search)}
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.fetchData(true, this.state.filters),
            },
            // {
            //   type: "export",
            //   title: language[this.props.defaultLanguage].export_,
            //   button_type: "dropdown",
            //   icon: "bx bxs-download",
            //   options: [
            //     {
            //       name: "PDF",
            //       onPress: () => this.downloadPDF(this.state.filters),
            //     },
            //     {
            //       name: "CSV",
            //       onPress: () => this.downloadExcel(this.state.filters),
            //     },
            //   ],
            // },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_COLLECTIONS,
                operation: "delete",
              }),
              name: language[this.props.defaultLanguage].delete,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].packaging
              ),
              icon: icons.delete,
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          {this.state.selectedData.status === "pending" ? (
            <DeleteModal
              handleCloseModal={this.handleCloseModal.bind(
                this,
                "showDeleteModal"
              )}
              error={this.state.error.delete_password}
              value={this.state.delete_value}
              onDelete={this.onDelete.bind(this)}
              onChange={(e) => this.onChangeText("delete_value", e)}
              isDeleting={this.state.isDeleting}
              name={this.state.selectedData.name}
              getData={this.getData.bind(this)}
            />
          ) : (
            <center className="card-body">
              Unable to delete package with {this.state.selectedData.status}{" "}
              status
            </center>
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        ></Modal>

        <CSVLink
          ref={this.csvDownload}
          filename={"Packages"}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Packages);
